export const SITE_URL = "https://voklayemohajerat7.com";

export const BRAND = {
  name: "گروه وکلای مهاجرت ۷",
  short: "GM7",
  founder: "دکتر محمد احمدی",
  tagline: "وکالت تخصصی مهاجرت — از ارزیابی تا ویزا، کنار شما",
  years: 15,
};

export const CONTACT = {
  whatsapp: "17254658573",
  whatsappDisplay: "+1 725 465 8573",
  phonePrimary: "+1 (725) 465-8573",
  phonePrimaryIntl: "+17254658573",
  phoneSecondary: "+1 (814) 770-7091",
  phoneSecondaryIntl: "+18147707091",
  email: "info@gm7law.com",
  supportNote: "کارشناسان ما ۲۴ ساعته در خدمت شما هستند",
};

export const NAV = [
  { to: "/", label: "صفحه اصلی" },
  { to: "/countries", label: "کشورها" },
  { to: "/lawyers", label: "وکلا" },
  { to: "/tracking", label: "رهگیری پرونده" },
  { to: "/blog", label: "وبلاگ" },
  { to: "/contact", label: "تماس" },
];

export const STATS = [
  { value: 4500, suffix: "+", label: "پرونده موفق" },
  { value: 98, suffix: "٪", label: "نرخ موفقیت" },
  { value: 13, suffix: "", label: "سال سابقه" },
  { value: 35, suffix: "+", label: "وکیل و کارشناس" },
];

export const MARQUEE_ITEMS = [
  "تخصص پناهندگی و ویزای بشر دوستانه",
  "کیس مسیحیت در ۵۰ تا ۶۰ روز کاری",
  "پیدا کردن کارفرما تنها در ۴۸ ساعت در سایت کاریابی ما",
  "تسویه‌حساب پس از رسیدن به مقصد",
  "قرارداد نقدی و اقساطی ۱۰ ماهه",
  "بدون نیاز به مدرک زبان و تمکن مالی",
  "پشتیبانی ۲۴ ساعته در تمام مراحل",
  "همه قراردادها به دلار آمریکا",
];

export const whatsappLink = (text) =>
  `https://wa.me/${CONTACT.whatsapp}?text=${encodeURIComponent(text)}`;
